import history from '../routes/history'
import {
  getLocalStorage,
  setLocalStorage,
  getSessionStorage,
  setSessionStorage,
} from './token'

export const getToken = () =>
  getSessionStorage('Heco-Authorization') ||
  getLocalStorage('Heco-Authorization')

export const setToken = (value) => setLocalStorage('Heco-Authorization', value)

export const getSessionToken = () => getSessionStorage('Heco-Authorization')

export const setSessionToken = (value) =>
  setSessionStorage('Heco-Authorization', value)

export const getSessionId = () => getSessionStorage('session-id')

export const setSessionId = (value) => setSessionStorage('session-id', value)

export const getUserName = () => getSessionStorage('username')

export const setUserName = (value) => setSessionStorage('username', value)

export const getCompanyName = () => getSessionStorage('companyname')

export const setCompanyName = (value) => setSessionStorage('companyname', value)

export const getIsInstaller = () => getSessionStorage('installer')

export const setIsInstaller = (value) => setSessionStorage('installer', value)

export const clearSessionValues = () => {
  sessionStorage.clear()
}
